<div nz-row>
  <div nz-col nzSpan="24" style="margin-bottom: 1rem;" class="no-form">
    <h1> Compila bozza </h1>
  </div>
</div>
<div class="centered-box-vertical extralarge">
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <form autocomplete="off" nz-form class="custom-form extralarge" [formGroup]="getFormGroup('personalData')" (ngSubmit)="compileDraft()" nzLayout="vertical">
      <h1 class="login"> Dati personali </h1>
      <div nz-row nzJustify="space-between">
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.FiscalCode|label for form FiscalCode@@Draft.CompileDraft.FiscalCode">
                Codice Fiscale
            </nz-form-label>
            <nz-form-control nzHasFeedback>
                <nz-input-group nzPrefixIcon="idcard" class="login disabledForm" >
                <input nz-input name="fiscalCode"
                    placeholder="fiscalCode" formControlName="fiscalCode" [readonly]="true" class="disabledForm">
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
          <div *ngIf="showFiscalCodeError">
            <p class="alert"> {{fiscalCodeErrorMsg}} </p>
          </div>
        </div>
        <div nz-col nzSpan="5"></div>
        <div nz-col nzSpan="5"></div>
        <div nz-col nzSpan="5"></div>
      </div>
      <div nz-row nzJustify="space-between">
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.FirstName|label for form firstname@@Draft.CompileDraft.FirstName">
                Nome
            </nz-form-label>
            <nz-form-control nzHasFeedback >
                <nz-input-group nzPrefixIcon="user" class="login">
                <input nz-input name="firstName"
                    placeholder="Nome" formControlName="firstName"/>
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.LastName|label for form lastName@@Draft.CompileDraft.LastName">
                Cognome
            </nz-form-label>
            <nz-form-control nzHasFeedback >
                <nz-input-group nzPrefixIcon="user" class="login">
                <input nz-input name="lastName"
                    placeholder="Cognome" formControlName="lastName" />
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
              i18n="Draft.CompileDraft.BirthDate|label for form BirthDate@@Draft.CompileDraft.BirthDate">
              Data di nascita
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getErrorFromSerializationField('personalData', 'birthDate')">
              <nz-date-picker nzFormat="dd/MM/yyyy" formControlName="birthDate" class="login"
                nzPlaceHolder="dd/MM/yyyy" [nzDisabledDate]="disabledFutureDate"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
              i18n="Draft.CompileDraft.Sex|label for form Sex@@Draft.CompileDraft.Sex">
              Sesso
            </nz-form-label>
            <nz-form-control>
              <nz-input-group nzPrefixIcon="woman" class="login sex">
                <nz-select formControlName="sex" nzPlaceHolder="M/F">
                  <nz-option nzValue="M"
                    nzLabel="M"></nz-option>
                  <nz-option nzValue="F"
                    nzLabel="F"></nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row nzJustify="space-between">
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
              i18n="Draft.CompileDraft.BirthState|label for form BirthState@@Draft.CompileDraft.BirthState">
              Stato di nascita
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getErrorFromSerializationField('personalData', 'birthCountry')">
              <nz-input-group  nzPrefixIcon="environment" class="login">
                <nz-select
                  id="birthCountry"
                  formControlName="birthCountry"
                  [nzShowArrow]="false"
                  nzShowSearch
                  nzServerSearch
                  nzPlaceHolder="Stato di nascita"
                  (nzOnSearch)="lookUpCountries($event, true)"
                  (nzScrollToBottom)="loadMoreCountries(true)"
                >
                  <ng-container *ngIf="!(areLoadingBirthCountries$ | async)">
                    <nz-option *ngFor="let country of birthCountries$ | async" [nzLabel]="country.text" [nzValue]="country.id"></nz-option>
                  </ng-container>
                  <nz-option nzDisabled nzCustomContent *ngIf="showBirthCountrySpinner$ | async">
                    <span nz-icon nzType="loading" class="loading-icon"></span>
                    Carico...
                  </nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
            i18n="Draft.CompileDraft.BirthProvince|label for form BirthProvince@@Draft.CompileDraft.BirthProvince">
            Provincia di nascita
          </nz-form-label>
          <nz-form-control [nzErrorTip]="getErrorFromSerializationField('personalData', 'birthProvince')">
            <nz-input-group nzPrefixIcon="environment" class="login">
              <nz-select
                id="birthProvince"
                [formControlName]="'birthProvince'"
                [nzShowArrow]="false"
                nzShowSearch
                nzServerSearch
                nzPlaceHolder="Provincia di nascita"
                (nzOnSearch)="lookUpProvinces($event, true)"
                (nzScrollToBottom)="loadMoreProvincies(true)"
              >
                <ng-container *ngIf="!(areLoadingBirthProvincies$ | async)">
                  <nz-option *ngFor="let province of birthProvincies$ | async" [nzLabel]="province.text" [nzValue]="province.id"></nz-option>
                </ng-container>
                <nz-option nzDisabled nzCustomContent *ngIf="showBirthProvinceSpinner$ | async">
                  <span nz-icon nzType="loading" class="loading-icon"></span>
                  Carico...
                </nz-option>
              </nz-select>
            </nz-input-group>
          </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
            i18n="Draft.CompileDraft.BirthCity|label for form BirthCity@@Draft.CompileDraft.BirthCity">
            Città di nascita
          </nz-form-label>
          <nz-form-control [nzErrorTip]="getErrorFromSerializationField('personalData', 'birthCity')">
            <nz-input-group nzPrefixIcon="environment" class="login">
              <nz-select
                id="birthCity"
                [formControlName]="'birthCity'"
                [nzShowArrow]="false"
                nzShowSearch
                nzServerSearch
                nzPlaceHolder="Città di nascita"
                (nzOnSearch)="lookUpCities($event, true)"
                (nzScrollToBottom)="loadMoreCities(true)"
              >
                <ng-container *ngIf="!(areLoadingBirthCities$ | async)">
                  <nz-option *ngFor="let city of birthCities$ | async" [nzLabel]="city.text" [nzValue]="city.id"></nz-option>
                </ng-container>
                <nz-option nzDisabled nzCustomContent *ngIf="showBirthCitySpinner$ | async">
                  <span nz-icon nzType="loading" class="loading-icon"></span>
                  Carico...
                </nz-option>
              </nz-select>
            </nz-input-group>
          </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol"></div>
      </div>

      <div nz-row nzJustify="space-between">
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.FiscalCodeCardId|label for form FiscalCodeCardId@@Draft.CompileDraft.FiscalCodeCardId">
                Numero tessera sanitaria
            </nz-form-label>
            <nz-form-control nzHasFeedback [nzErrorTip]="getErrorFromSerializationField('personalData', 'fiscalCodeCardId', 'Il dato deve essere composto da 20 cifre numeriche')">
                <nz-input-group nzPrefixIcon="idcard" class="login">
                <input nz-input name="fiscalCodeCardId"
                    placeholder="Numero tessera sanitaria" formControlName="fiscalCodeCardId" />
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.fiscalCodeCardExpirationDate|label for form fiscalCodeCardExpirationDate@@Draft.CompileDraft.fiscalCodeCardExpirationDate">
                Scadenza tessera sanitaria
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getErrorFromSerializationField('personalData', 'fiscalCodeCardExpirationDate')">
              <nz-date-picker nzFormat="dd/MM/yyyy" formControlName="fiscalCodeCardExpirationDate" class="login"
                nzPlaceHolder="dd/MM/yyyy" [nzDisabledDate]="disabledPastDate"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol"></div>
        <div nz-col nzSpan="5" class="no-form marginCol"></div>
      </div>
    </form>

    <form autocomplete="off" nz-form class="custom-form extralarge" [formGroup]="getFormGroup('residence')" (ngSubmit)="compileDraft()" nzLayout="vertical">
      <h1 class="login"> Residenza </h1>
      <div nz-row nzJustify="space-between">
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
              i18n="Draft.CompileDraft.State|label for form State@@Draft.CompileDraft.State">
              Stato
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getErrorFromSerializationField('residence', 'country')">
              <nz-input-group  nzPrefixIcon="environment" class="login">
                <nz-select
                  formControlName="country"
                  [nzShowArrow]="false"
                   nzShowSearch
                  nzServerSearch
                  nzPlaceHolder="Stato"
                  (nzOnSearch)="lookUpCountries($event)"
                  (nzScrollToBottom)="loadMoreCountries()"
                >
                  <ng-container *ngIf="!(areLoadingCountries$ | async)">
                    <nz-option *ngFor="let country of countries$ | async" [nzLabel]="country.text" [nzValue]="country.id"></nz-option>
                  </ng-container>
                  <nz-option nzDisabled nzCustomContent *ngIf="showCountrySpinner$ | async">
                    <span nz-icon nzType="loading" class="loading-icon"></span>
                    Carico...
                  </nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
              i18n="Draft.CompileDraft.Province|label for form Province@@Draft.CompileDraft.Province">
              Provincia
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getErrorFromSerializationField('residence', 'province')">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <nz-select
                  id="province"
                  [formControlName]="'province'"
                  [nzShowArrow]="false"
                  nzShowSearch
                  nzServerSearch
                  nzPlaceHolder="Provincia"
                  (nzOnSearch)="lookUpProvinces($event)"
                  (nzScrollToBottom)="loadMoreProvincies()"
                >
                  <ng-container *ngIf="!(areLoadingProvincies$ | async)">
                    <nz-option *ngFor="let province of provincies$ | async" [nzLabel]="province.text" [nzValue]="province.id"></nz-option>
                  </ng-container>
                  <nz-option nzDisabled nzCustomContent *ngIf="showProvinceSpinner$ | async">
                    <span nz-icon nzType="loading" class="loading-icon"></span>
                    Carico...
                  </nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
              i18n="Draft.CompileDraft.City|label for form City@@Draft.CompileDraft.City">
              Città
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getErrorFromSerializationField('residence', 'city')">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <nz-select
                  id="city"
                  [formControlName]="'city'"
                  [nzShowArrow]="false"
                  nzShowSearch
                  nzServerSearch
                  nzPlaceHolder="Città"
                  (nzOnSearch)="lookUpCities($event)"
                  (nzScrollToBottom)="loadMoreCities()"
                >
                  <ng-container *ngIf="!(areLoadingCities$ | async)">
                    <nz-option *ngFor="let city of cities$ | async" [nzLabel]="city.text" [nzValue]="city.id"></nz-option>
                  </ng-container>
                  <nz-option nzDisabled nzCustomContent *ngIf="showCitySpinner$ | async">
                    <span nz-icon nzType="loading" class="loading-icon"></span>
                    Carico...
                  </nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
              i18n="Draft.CompileDraft.ZipCode|label for form ZipCode@@Draft.CompileDraft.ZipCode">
              Zip
            </nz-form-label>
            <nz-form-control nzHasFeedback [nzErrorTip]="getErrorFromSerializationField('residence', 'zipCode', 'Il codice postale deve contenere 5 cifre')">
                <nz-input-group nzPrefixIcon="environment" class="login">
                <input nz-input name="zipCode"
                    placeholder="CAP" formControlName="zipCode" />
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row nzJustify="space-between">
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
              i18n="Draft.CompileDraft.AddressType|label for form AddressType@@Draft.CompileDraft.AddressType">
              Tipo indirizzo
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getErrorFromSerializationField('residence', 'addressType')">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <nz-select id="addressType" formControlName="addressType"
                  [nzShowArrow]="false" nzShowSearch nzPlaceHolder="Via">
                  <nz-option *ngFor="let addressType of addressTypes"
                    [nzValue]="addressType.key"
                    [nzLabel]="addressType.label">
                  </nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.AddressName|label for form AddressName@@Draft.CompileDraft.AddressName">
                Indirizzo
            </nz-form-label>
            <nz-form-control nzHasFeedback >
                <nz-input-group nzPrefixIcon="environment" class="login">
                <input nz-input name="addressName"
                    placeholder="Indirizzo" formControlName="addressName" />
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
              i18n="Draft.CompileDraft.AddressNumber|label for form AddressNumber@@Draft.CompileDraft.AddressNumber">
              Numero
            </nz-form-label>
            <nz-form-control nzHasFeedback >
                <nz-input-group nzPrefixIcon="environment" class="login">
                <input nz-input name="addressNumber"
                    placeholder="Numero civico" formControlName="addressNumber" />
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol"></div>
      </div>
    </form>

    <form autocomplete="off" class="custom-form extralarge" [formGroup]="getFormGroup('identityDocument')" (ngSubmit)="compileDraft()" nzLayout="vertical">
      <h1 class="login"> Documento d'identità </h1>
      <div nz-row nzJustify="space-between">
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.idDocumentType|label for form idDocumentType@@Draft.CompileDraft.idDocumentType">
                Tipologia documento
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getErrorFromSerializationField('identityDocument', 'idDocumentType')">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <nz-select formControlName="idDocumentType" class="login"
                nzPlaceHolder="Carta identità">
                  <nz-option nzValue="IC" nzLabel="Carta d'identità"></nz-option>
                  <nz-option nzValue="PS" nzLabel="Passaporto"></nz-option>
                  <nz-option nzValue="DL" nzLabel="Patente"></nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
              i18n="Draft.CompileDraft.idDocumentIssuerType|label for form idDocumentIssuerType@@Draft.CompileDraft.idDocumentIssuerType">
              Tipologia ente emettitore
            </nz-form-label>
            <nz-input-group nzPrefixIcon="environment" class="login">
              <nz-select formControlName="idDocumentIssuerType" nzShowSearch nzPlaceHolder="Comune">
                <nz-option nzValue="COMUNE" nzLabel="Comune"></nz-option>
                <nz-option nzValue="QUESTURA" nzLabel="Questura"></nz-option>
                <nz-option nzValue="PREFETTURA" nzLabel="Prefettura"></nz-option>
                <nz-option nzValue="MCTC" nzLabel="Motorizzazione Civile"></nz-option>
                <nz-option nzValue="MIT" nzLabel="Ministero delle Infrastrutture e dei Trasporti"></nz-option>
                <nz-option nzValue="MIT_UCO"
                  nzLabel="Ufficio Centrale Operativo del Ministero delle Infrastrutture e dei Trasporti"></nz-option>
                <nz-option nzValue="MAECI" nzLabel="Ministero degli Affari esteri e della Cooperazione internazionale">
                </nz-option>
                <nz-option nzValue="CONSOLATO" nzLabel="Consolato Generale d\'Italia"></nz-option>
                <nz-option nzValue="AMBASCIATA" nzLabel="Ambasciata"></nz-option>
              </nz-select>
            </nz-input-group>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5"  class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.idDocumentIssuerName|label for form idDocumentIssuerName@@Draft.CompileDraft.idDocumentIssuerName">
                Ente emettitore
            </nz-form-label>
            <nz-form-control nzHasFeedback [nzErrorTip]="getErrorFromSerializationField('identityDocument', 'idDocumentIssuerName')">
                <nz-input-group nzPrefixIcon="idcard" class="login">
                <input
                  nz-input
                  name="idDocumentIssuerName"
                  placeholder="Ente emettitore"
                  formControlName="idDocumentIssuerName"
                />
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5"  class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.idDocumentNumber|label for form idDocumentNumber@@Draft.CompileDraft.idDocumentNumber">
                Numero documento
            </nz-form-label>
            <nz-form-control nzHasFeedback [nzErrorTip]="getErrorFromSerializationField('identityDocument', 'idDocumentNumber')" >
                <nz-input-group nzPrefixIcon="idcard" class="login">
                <input nz-input name="idDocumentNumber"
                    placeholder="Numero documento" formControlName="idDocumentNumber" />
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row nzJustify="space-between">
        <div nz-col nzSpan="5"  class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.idDocumentIssueDate|label for form idDocumentIssueDate@@Draft.CompileDraft.idDocumentIssueDate">
                Data rilascio documento
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getErrorFromSerializationField('identityDocument', 'idDocumentIssueDate')">
              <nz-date-picker nzFormat="dd/MM/yyyy" formControlName="idDocumentIssueDate" class="login"
                nzPlaceHolder="dd/MM/yyyy" [nzDisabledDate]="disabledFutureDate"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5"  class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.idDocumentExpirationDate|label for form idDocumentExpirationDate@@Draft.CompileDraft.idDocumentExpirationDate">
                Scadenza documento
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getErrorFromSerializationField('identityDocument', 'idDocumentExpirationDate')">
              <nz-date-picker nzFormat="dd/MM/yyyy" formControlName="idDocumentExpirationDate" class="login"
                nzPlaceHolder="dd/MM/yyyy" [nzDisabledDate]="disabledPastDate"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol"></div>
        <div nz-col nzSpan="5" class="no-form marginCol"></div>
      </div>
    </form>

    <form autocomplete="off" nz-form class="custom-form extralarge" [formGroup]="getFormGroup('contact')" (ngSubmit)="compileDraft()" nzLayout="vertical">
      <h1 class="login"> Contatto </h1>
      <div nz-row nzJustify="space-between">
        <div nz-col nzSpan="5"  class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.Phone|label for form Phone@@Draft.CompileDraft.Phone">
                Telefono
            </nz-form-label>
            <nz-form-control nzHasFeedback [nzErrorTip]="getErrorFromSerializationField('contact', 'phone')">
              <input ng2TelInput class="phoneForm"
                (countryChange)="onCountryChange(true, $event)" (ngModelChange)="onValidatePhone()"
                (intlTelInputObject)="telInputObject(true, $event)"
                [ng2TelInputOptions]="{initialCountry: 'it', nationalMode: false, autoHideDialCode: false, formatOnDisplay: false}"
                autocomplete="off" name="phone" formControlName="phone" placeholder="Cellulare"/>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5"  class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label nzRequired
                i18n="Draft.CompileDraft.Email|label for form Email@@Draft.CompileDraft.Email">
                E-mail
            </nz-form-label>
            <nz-form-control nzHasFeedback >
                <nz-input-group nzPrefixIcon="mail" class="login disabledForm" >
                <input nz-input name="email"
                    placeholder="email" formControlName="email" [readonly]="true" class="disabledForm"/>
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5"  class="no-form marginCol">
          <nz-form-item class="login">
            <nz-form-label
              i18n="Draft.CompileDraft.Pec|label for form Pec@@Draft.CompileDraft.Pec">
              PEC
            </nz-form-label>
            <nz-form-control nzHasFeedback >
                <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="pec"
                    placeholder="pec" formControlName="pec" />
                </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="5" class="no-form marginCol">
        </div>
      </div>
      <div nz-row class="full-width" nzJustify="end" nzAlign="top" >
      <div nz-col nzSpan="4">
        <button class="submit" nz-button nzType="primary" [disabled]="validateForm.invalid"> Compila </button>
      </div>
    </div>
    </form>
  </nz-spin>
</div>
